import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";

interface ControlledAudioProps
  extends React.AudioHTMLAttributes<HTMLAudioElement> {
  src?: string;
  isPlaying?: boolean;
  onEnded?: (e: React.SyntheticEvent<HTMLAudioElement>) => void;
}

export const ControlledAudio = forwardRef<
  HTMLAudioElement,
  ControlledAudioProps
>((props: ControlledAudioProps, ref) => {
  const { src = "", isPlaying = false, onEnded, ...rest } = props;
  const internalRef = useRef<HTMLAudioElement>(null);

  // @ts-expect-error - ref forwarding with null initial value
  useImperativeHandle(ref, () => internalRef.current, []);

  useEffect(() => {
    const audioEl = internalRef.current;

    if (!audioEl) return;

    if (isPlaying) {
      audioEl.play().catch(() => {
        // Browser may reject play() if source isn't loaded yet or format unsupported
      });
    } else {
      audioEl.pause();
    }
  }, [isPlaying]);

  if (!src) return null;

  return <audio ref={internalRef} src={src} onEnded={onEnded} {...rest} />;
});
